export const BANK_ACCOUNT_STATUS = {
  ACTIVE: "ACTIVE",
  CLOSED: "CLOSED",
} as const;

export const BANK_CONNECTION_TYPE = {
  PLAID: "PLAID",
  DIRECT: "DIRECT",
  MANUAL: "MANUAL",
} as const;

export const BANK_CONNECTION_PROVIDER = {
  BREX: "BREX",
  MERCURY: "MERCURY",
  MANUAL: "MANUAL",
  STRIPE: "STRIPE",
  SVB: "SVB",
  BILL_DOT_COM: "BILL.COM",
  HUBSPOT: "HUBSPOT",
  RHO: "RHO",
  NA: "NA",
} as const;

export const LAST_RECONCILATION_STATUS = {
  COMPLETED: "COMPLETED",
  ONGOING: "ONGOING",
  PENDING: "PENDING",
  EXPIRED: "EXPIRED",
} as const;

export const ACCOUNT_CONNECTION_TYPE = {
  ALL: "ALL",
  BANK_AND_CREDIT_CARD: "BANK_AND_CREDIT_CARD",
  REVENUE: "REVENUE",
  PAYROLL: "PAYROLL",
  AP_AR: "AP_AR",
} as const;

export type AccountConnectionType = keyof typeof ACCOUNT_CONNECTION_TYPE;

export const GUSTO = "gusto";

export type BankAccountStatusType = keyof typeof BANK_ACCOUNT_STATUS;

export const CONNECTION_AUTHENTICATION_SUCCESS =
  "CONNECTION_AUTHENTICATION_SUCCESS";

export const CONNECTION_AUTHENTICATION_FAILED =
  "CONNECTION_AUTHENTICATION_FAILED";

export const BANK_STATEMENT_RESPONSE_CODE = {
  LOADING_STATEMENTS: "LOADING_STATEMENTS",
  STATEMENT_NOT_SUPPORTED: "STATEMENT_NOT_SUPPORTED",
} as const;

export const CODE_RECEIVED = "CODE_RECEIVED";

export const AI_RECONCILE_TXN_ACTION = {
  RECONCILE: "reconcile",
  DO_NOT_RECONCILE: "do_not_reconcile",
  EXCLUDE: "exclude",
} as const;

export type AIReconcileTxnActionType =
  (typeof AI_RECONCILE_TXN_ACTION)[keyof typeof AI_RECONCILE_TXN_ACTION];

export const AI_RECONCILE_MISSING_TXN_ACTION = {
  CREATE_AND_RECONCILE: "create_and_reconcile",
  DO_NOT_CREATE: "do_not_create",
} as const;

export type AIReconcileMissingActionType =
  (typeof AI_RECONCILE_MISSING_TXN_ACTION)[keyof typeof AI_RECONCILE_MISSING_TXN_ACTION];

export const AI_RECONCILE_SECTION_TYPE = {
  PAIRED: "paired",
  MISSING_IN_BOOKS: "missing_in_books",
} as const;

export type AIReconcileSectionType =
  (typeof AI_RECONCILE_SECTION_TYPE)[keyof typeof AI_RECONCILE_SECTION_TYPE];
